import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { ApiState } from '@comparit/core';
import type { VorgangDocument } from '@comparit/common-api';
import { DokumentDownloadButtonComponent } from './dokument-download-button/dokument-download-button.component';

/** The "Tarifdokumente" box: the insurer's documents from get-order, with a skeleton while it runs. */
@Component({
  selector: 'ui-tarif-dokumente',
  templateUrl: './tarif-dokumente.component.html',
  styleUrl: './tarif-dokumente.component.scss',
  imports: [DokumentDownloadButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TarifDokumenteComponent {
  readonly dokumente = input.required<VorgangDocument[]>();
  /** Loading state of the document set; drives the skeleton / error placeholder. */
  readonly state = input<ApiState<unknown>['state']>('success');
}
